import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/assistance/$id/edit')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/_authenticated/assistance/$id/edit"!</div>
}
